'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchSuggestionsRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _config = require('../../../config');

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SearchSuggestionsRemote = exports.SearchSuggestionsRemote = {
    fetchSuggestions: function fetchSuggestions(_ref) {
        var deployment = _ref.deployment,
            term = _ref.term;

        if (!term) {
            return _promise2.default.all([]);
        }
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({
                deployment: deployment,
                path: '<MAINHOST-API>api/search/' + encodeURIComponent(term.trim()) + '/suggestions',
                queryParams: {
                    auctionHouseSize: _config.auctionHouseSize,
                    client_version: '5.0',
                    giveRawResults: _config.giveRawResults,
                    querySize: _config.querySize
                }
            });
            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({ err: err, reject: reject, resolve: resolve, response: response });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/searchSuggestions.js
// module id = FGjK
// module chunks = 60